<template>
  <div>
    <!-- Table Container Card -->
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <!-- Datos cargados -->
        <b-card-header class="pb-0">
          <b-card-title />
          <b-card-text class="font-small-2 mr-25 mb-0">
            <!-- Datos cargados -->
          </b-card-text>
        </b-card-header>

        <!-- Table Top -->
        <div class="m-2">
          <b-row>
            <!-- Cantidad de elementos por página -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <!-- <span>Mostrar</span>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              /> { name: 'contacto'}-->
              <b-button
                variant="primary"
                @click="siguienteRuta()"
              >
                Nuevo registro
              </b-button>
              <b-button
                v-show="getRol.id == 1"
                class="ml-2"
                variant="success"
                to="/compras/list"
              >
                Volver a las solicitudes
              </b-button>
            </b-col>

            <!-- Buscador -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    placeholder="Buscar"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refDataListTable"
          class="position-relative"
          empty-text="No se encontraron resultados"
          primary-key="id"
          responsive
          show-empty
          striped
          :items="fetchData"
          :fields="tableColumns"
          :sort-desc.sync="isSortDirDesc"
          :sort-by.sync="sortBy"
        >
          <template #cell(id)="data">
            <div class="text-nowrap text-center">
              <!-- <b-form-radio
                v-model="checked"
                :value="data.item.id"
              >
                {{ data.item.id }}
              </b-form-radio> -->
              <b-link
                class="font-weight-bold text-secondary"
                @click="siguienteRuta(data.item.id)"
              >
                <feather-icon
                  :id="`curso-row-${data.item.id}-edit-icon`"
                  icon="EditIcon"
                  class="cursor-pointer"
                  size="16"
                  :class="data.item.activo ? 'mx-1' : 'mr-1'"
                />
              </b-link>
              <b-tooltip
                title="Editar registro"
                placement="right"
                :target="`curso-row-${data.item.id}-edit-icon`"
              />
              <span>{{ data.item.id }}</span>
            </div>
          </template>
        </b-table>
        <!-- Table's footer & pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Leyenda de cuantos elementos se muestran -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BTooltip,
  BLink,
  BCardHeader,
  BCardText,
  BCardTitle,
  BInputGroup,
  BButton,
  BInputGroupPrepend,
  BOverlay,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import { useRouter, isEmptyObject } from '@core/utils/utils'
import { configTableFactura } from '@/views/campus/cuenta/useDatosFacturacion'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BTooltip,
    BLink,
    BCardHeader,
    BCardTitle,
    BCardText,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    // vSelect,
    BOverlay,
  },
  props: {
    persona: {
      type: [Number, null],
      default: null,
    },
  },
  computed: {
    getRol() {
      if (isEmptyObject(this.$store.getters['cuenta/rolCurrent'])) {
        return ({})
      } return this.$store.getters['cuenta/rolCurrent']
    },
  },
  setup(props) {
    const checked = ref([])
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false, table: false })
    const { router } = useRouter() //* Use router propieties
    const { tableColumns, configRequest } = configTableFactura()
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    // aqui tambien tango que cambiar la vista, si es para persona o para matricula
    if (props.persona !== null) { // mandan por props a la persona
      configRequest.value.wsType = 'wsinscripcion'
      configRequest.value.wsParams.IdPersona = props.persona
      configRequest.value.wsParams.action = 20
      delete configRequest.value.wsParams.token
    }
    //* On mounted
    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
    })
    // :to="`/cuenta/nueva-facturacion/${data.item.id}/${persona}`"
    const siguienteRuta = (idTemp = 'null') => {
      if (props.persona !== null) { // si estan usando persona
        router.push(`/nueva-facturacion/${idTemp}/${props.persona}`)
      } else {
        router.push(`/cuenta/nueva-facturacion/${idTemp}/${props.persona}`)
      }
    }

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      checked,
      siguienteRuta,

      // Extra Filters
      configRequest,

      // Loader
      loader,
      isBusyTable,

      // Error
      errorContent,
    }
  },
}
</script>

<style>

</style>
